import { render, staticRenderFns } from "./userRoleList.vue?vue&type=template&id=10f07729&"
import script from "./userRoleList.vue?vue&type=script&lang=js&"
export * from "./userRoleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports